<script>
    import { Text, Flex } from "@axel669/zephyr"
</script>

<Flex>
    <Text size="info">Info</Text>
    <Text size="subtitle">Subtitle</Text>
    <Text>Normal</Text>
    <Text size="header">Header</Text>
    <Text size="title">Title</Text>
</Flex>
